export const MQTT_MQTTIP = "wss:test.youjiaminsu.cn:443/ws";
export const MQTT_USERNAME = "admin";
export const MQTT_PASSWORD = "admin";
